// extracted by mini-css-extract-plugin
export default {"root":"ProtectedHint__root--2TmYg","noMargin":"ProtectedHint__noMargin--1hfUg","rootHovered":"ProtectedHint__rootHovered--Vv7n1"};